import {
  ErrorHandler,
  Inject,
  Injectable,
  Injector,
  OnDestroy,
} from '@angular/core';
import {Store} from '@ngrx/store';
import {CommerceError} from './commerce-error';
import {uncaughtError} from './error-handling.actions';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler, OnDestroy {
  private _store: Store;
  private _storeLookupTimeoutId?: ReturnType<typeof setTimeout>;

  constructor(@Inject(Injector) injector: Injector) {
    this._storeLookupTimeoutId = setTimeout(() => {
      this._store = injector.get(Store);
      this._storeLookupTimeoutId = undefined;
    });
  }

  handleError(unhandledError: Error): void {
    const error = new CommerceError(
      unhandledError.message,
      unhandledError.stack,
    );
    this._store.dispatch(uncaughtError({error}));
  }

  ngOnDestroy(): void {
    if (this._storeLookupTimeoutId) {
      clearTimeout(this._storeLookupTimeoutId);
    }
  }
}
